/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gallery_Offer_LabelInputs */

const en_us2_gallery_offer_label = /** @type {(inputs: Gallery_Offer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The plan's name in the gallery`)
};

const pt_br2_gallery_offer_label = /** @type {(inputs: Gallery_Offer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do plano na galeria`)
};

const pt_pt2_gallery_offer_label = /** @type {(inputs: Gallery_Offer_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome do plano na galeria`)
};

/** @type {(inputs: Gallery_Offer_LabelInputs) => LocalizedString} */
const es_419_gallery_offer_label = en_us2_gallery_offer_label;

/** @type {(inputs: Gallery_Offer_LabelInputs) => LocalizedString} */
const fr_fr2_gallery_offer_label = en_us2_gallery_offer_label;

/** @type {(inputs: Gallery_Offer_LabelInputs) => LocalizedString} */
const de_de2_gallery_offer_label = en_us2_gallery_offer_label;

/** @type {(inputs: Gallery_Offer_LabelInputs) => LocalizedString} */
const it_it2_gallery_offer_label = en_us2_gallery_offer_label;

/**
* | output |
* | --- |
* | "The plan's name in the gallery" |
*
* @param {Gallery_Offer_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gallery_offer_label = /** @type {((inputs?: Gallery_Offer_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gallery_Offer_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gallery_offer_label(inputs)
	if (locale === "es-419") return es_419_gallery_offer_label(inputs)
	if (locale === "pt-PT") return pt_pt2_gallery_offer_label(inputs)
	if (locale === "fr-FR") return fr_fr2_gallery_offer_label(inputs)
	if (locale === "de-DE") return de_de2_gallery_offer_label(inputs)
	if (locale === "it-IT") return it_it2_gallery_offer_label(inputs)
	return en_us2_gallery_offer_label(inputs)
});
export { gallery_offer_label as "gallery.offer_label" }